/**
 * Review Center service.
 * One aggregated read for the executive/review dashboard, plus the inline
 * actions the queue supports (currently Resend; others drill through).
 */
import { api } from './api';
import { notificationRunsService } from './notification-runs.service';
import type { ReviewCenterData } from '../types/review-center.types';

const BASE = '/api/v1/dashboard';

export const reviewCenterService = {
  /** Fetch the whole dashboard payload for a look-back window (days). */
  get: async (days = 30): Promise<ReviewCenterData | null> => {
    try {
      const res = await api.get<{ data: ReviewCenterData }>(
        `${BASE}/review-center`,
        { params: { days } },
      );
      return res.data.data;
    } catch (err) {
      console.warn('Failed to load review center:', err);
      return null;
    }
  },

  /**
   * Inline action: re-send a notification run's failed deliveries (an engine
   * replay of the failed recipients). True when the replay produced a new run.
   */
  resendNotification: async (notificationId: string): Promise<boolean> => {
    try {
      const res = await notificationRunsService.replay(notificationId);
      return (res?.notifications?.length ?? 0) > 0;
    } catch (err) {
      console.warn('Resend failed:', err);
      return false;
    }
  },
};
